var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.757 6.49a17.35 17.35 0 0 1 1.77 2.013c.545.725 1.037 1.5 1.473 2.313l-3.995 3.62-10.54 9.555a10.235 10.235 0 0 1-3.298-.727c1.191.483 2.477.751 3.821.751 2.527 0 4.855-.929 6.723-2.488a11.754 11.754 0 0 0 1.9-2.008c.527-.708.98-1.482 1.354-2.309L30 20.866a18.008 18.008 0 0 1-1.431 2.238 17.296 17.296 0 0 1-1.831 2.072c-2.863 2.759-6.613 4.431-10.72 4.431-4.134 0-7.907-1.697-10.776-4.49a17.386 17.386 0 0 1-1.772-2.013A18.092 18.092 0 0 1 2 20.792l3.995-3.62 10.54-9.554c-.052-.002-.103-.006-.155-.009-.122-.008-.244-.016-.368-.016-2.527 0-4.854.93-6.723 2.488a11.766 11.766 0 0 0-1.9 2.008c-.527.708-.98 1.483-1.354 2.31L2 10.74c.427-.787.903-1.537 1.431-2.24a17.294 17.294 0 0 1 1.831-2.07C8.124 3.671 11.874 2 15.981 2c1.955 0 3.828.384 5.564 1.08a15.946 15.946 0 0 1 4.74 2.97c.16.144.318.29.472.44zm-4.51 3.216L9.235 21.501c.153.13.314.25.475.37l.042.032 13.014-11.795a10.602 10.602 0 0 0-.47-.365l-.048-.036z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZam);
export default __webpack_public_path__ + "static/media/ZAM.7ead3213151e83153f95b857a606cdec.svg";
export { ForwardRef as ReactComponent };